import { useEffect, useRef } from "preact/hooks";

/**
 * Hook that returns the last value passed to the function.
 *
 * @param props value to store.
 */
export function usePrevious<T>(props: T): T {
  const ref = useRef<T>(props);
  useEffect(() => {
    ref.current = props;
  });

  return ref.current;
}
